module.exports = __webpack_public_path__ + "static/media/buynowen.4b547b55.png";